export const selectTimeFilter = (state: any) => state.get('timeFilter');

export const selectTimezone = (state: any) => state.getIn(['timeFilter', 'timezone']);
